<template>
  <div id="app"
       class="count container-fluid min-vw-100 h-100 p-0"
       role="grid">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'Compte'
}
</script>

<style lang="scss" scoped>
main {
  padding: 0 !important;
}
.bg-GreyPoints {
  height: calc(100vh - 2.8rem);
}
#phylactere {
  padding: 4rem !important;
  border-radius: 2.8rem 2.8rem 0 2.8rem !important;
  border: 1px solid var(--dark);
  width: 30vw !important;
  max-width: 38rem !important;
  max-height: 38rem !important;
}

.group {
  border: 1px solid var(--dark) !important;
  width: 100% !important;
  height: 5.8rem !important;
  ::v-deep .bv-no-focus-ring {
    height: 100% !important;
    input {
      height: 100% !important;
    }
  }
}
#bar-bottom {
  .navbar {
    width: 100% !important;
    .navbar-nav {
      margin: 0 auto !important;
    }
    .nav-link {
      position: relative;
      color: var(--light) !important;
      bottom: 0.4rem !important;
      padding: 0 2rem !important;
    }
  }
}

#navbarNavBottom ul li.nav-item a {
  padding: 1rem !important;
  margin: 0 !important;
}

@media (max-width: 575px) {
  #navbarNavBottom ul li.nav-item a.border-right {
    border-right: none !important;
    border-bottom: 1px solid var(--light) !important;
  }
}

@media (max-width: 767px) {
  #bar-bottom {
    .navbar-nav {
      .nav-item {
        .nav-link {
          width: 20rem !important;
          margin: 0 auto !important;
          padding-top: 0.4rem !important;
          padding-bottom: 0.4rem !important
        }
      }

      .nav-item:not(:last-of-type) {
        .nav-link {
          border-bottom: 1px solid var(--light) !important;
        }
      }
    }
  }
}

@media (min-width: 768px) {
  #bar-bottom {
    .navbar {
      height: 2.9rem !important;

      .nav-item:not(:last-of-type) {
        height: 0.8rem !important;
        border-right: 1px solid var(--light) !important;
      }
    }
  }
}

</style>
